export default __webpack_public_path__ + "static/QCon_SF_2023-adcc5757bff9248c3df83f39b2a45b5e.jpg";